<form [formGroup]="group">
  <div fxFlex fxLayout="column">
    <span fxLayout="row" class="header">
      <span fxFlex fxLayoutAlign="center center">
        <span class="compliance-status medium" ngClass.xs="compliance-status xs-font medium">{{'add_group_name' | transloco}}
        </span>
      </span>
    </span>
    <mat-dialog-content>
      <div fxLayout="column" fxLayoutGap="20px" class="div-content" ngClass.xs="div-content-xs">
        <mat-form-field>
          <mat-label>{{'group_name' | transloco}}</mat-label>
          <input matInput formControlName="name">
        </mat-form-field>
        <span fxLayout="row" fxLayoutGap="20px">
          <button  fxFlex mat-stroked-button color="primary" style="border-radius: 24px;font-family: SLBSans-Medium;"
            (click)="onCancel()">{{ 'cancel' | transloco}}</button>
          <button  fxFlex mat-flat-button color="primary" class="btn-action" [disabled]="!group.valid"
            (click)="onSave()">{{ 'save' | transloco}}</button>
        </span>
      </div>
    </mat-dialog-content>

  </div>
</form>
